import { render, staticRenderFns } from "./StateBox.vue?vue&type=template&id=27573a10&scoped=true&"
import script from "./StateBox.vue?vue&type=script&lang=js&"
export * from "./StateBox.vue?vue&type=script&lang=js&"
import style0 from "./StateBox.vue?vue&type=style&index=0&id=27573a10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27573a10",
  null
  
)

export default component.exports